import { useEffect, useState } from "react";
import { connect, keyStores, WalletConnection, KeyPair, utils } from "near-api-js";
import useEnv from "./envHook";
import { Buffer } from "buffer";
global.Buffer = Buffer;

const keyStore = new keyStores.BrowserLocalStorageKeyStore();

const CONFIG_MAINNET = {
  headers: {},
  networkId: "mainnet",
  nodeUrl: "https://rpc.mainnet.near.org",
  walletUrl: "https://wallet.near.org",
  helperUrl: "https://helper.mainnet.near.org",
  keyStore,
};
const CONFIG_TESTNET = {
  headers: {},
  networkId: "testnet",
  nodeUrl: "https://rpc.testnet.near.org",
  walletUrl: "https://wallet.testnet.near.org",
  helperUrl: "https://helper.testnet.near.org",
  keyStore,
};

function hexToBytes(hex) {
  for (var bytes = [], c = 0; c < hex.length; c += 2)
    bytes.push(parseInt(hex.substr(c, 2), 16));
  return bytes;
}

function bytesToHex(bytes) {
  for (var hex = [], i = 0; i < bytes.length; i++) {
    var current = bytes[i] < 0 ? bytes[i] + 256 : bytes[i];
    hex.push((current >>> 4).toString(16));
    hex.push((current & 0xf).toString(16));
  }
  return hex.join("");
}

function _arrayBufferToBase64(buffer) {
  var binary = "";
  var bytes = new Uint8Array(buffer);
  var len = bytes.byteLength;
  for (var i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
}

const useNear = () => {
  const { useMainnet } = useEnv();
  const [near, setNear] = useState(null);
  const [wallet, setWallet] = useState(null);
  const [account, setAccount] = useState();
  const [accessKeyType, setAccessKeyType] = useState(null)
  const config = useMainnet ? CONFIG_MAINNET : CONFIG_TESTNET;

  useEffect(() => {
    connect(config).then((near) => {
      setNear(near)
      setWallet(new WalletConnection(near, "nt"));
    });
  }, []);

  const getAccessKeyType = async (_account) => {
    const keyPair = await keyStore.getKey(config.networkId, _account);
    // debugger;
    const result = await near.connection.provider.query({
      request_type: 'view_access_key',
      account_id: _account,
      public_key: keyPair.publicKey.toString(),
      finality: 'optimistic'
    })
    // console.log(result)
    return result.permission
  }

  useEffect(() => {
    if (!wallet) return;
    if (wallet.isSignedIn()) {
      const acc = wallet.account()
      // debugger;
      setAccount(acc.accountId);
    } else {
      setAccount(undefined);
    }
  }, [wallet]);

  useEffect(() => {
    if(!wallet) return;
    if(!wallet.isSignedIn()) return;
    if(accessKeyType) return;

    const timer = setInterval(() => {
      // console.log("poll access key type")
      getAccessKeyType(account).then(result => {
        setAccessKeyType(result)
        clearInterval(timer)
      })
    }, 500)

    return () => clearInterval(timer)
  }, [wallet, account])

  const login = async () => {
    if (!wallet) return;
    await wallet.requestSignIn(
      "sbt.testnet",
      "localtest.io",
      window.location.href,
      window.location.href
    );
    setAccount(wallet.account().accountId);
  };
  const logout = () => {
    wallet?.signOut();
    setAccount(undefined);
    setAccessKeyType(null)
    window.location.reload()
  };

  const loginFullAccess = async () => {
    if (!wallet) return;
    
    const currentUrl = new URL(window.location.href);
    const newUrl = new URL(wallet._walletBaseUrl + "/login/");
    newUrl.searchParams.set('success_url', currentUrl.href);
    newUrl.searchParams.set('failure_url', currentUrl.href);

    const PENDING_ACCESS_KEY_PREFIX = 'pending_key';
    
    const accessKey = KeyPair.fromRandom('ed25519');
    newUrl.searchParams.set('public_key', accessKey.getPublicKey().toString());
    await wallet._keyStore.setKey(wallet._networkId, PENDING_ACCESS_KEY_PREFIX + accessKey.getPublicKey(), accessKey);
    // debugger;

    window.location.assign(newUrl.toString());
  };

  const getKeyObject = async () => {
    const keyPair = await keyStore.getKey(config.networkId, account)

    return {
      account_id: account,
      public_key: keyPair.publicKey.toString(),
      private_key: `ed25519:${keyPair.secretKey}`
    }
  }

  const createSubAccount = async (accountId, initialBalance) => {
    const accessKey = KeyPair.fromRandom('ed25519');
    const nearAmount = utils.format.parseNearAmount(initialBalance.toString());
    console.log(accessKey)
    const result = await wallet.account().createAccount(accountId, accessKey.getPublicKey(), nearAmount);
    console.log(result)
    return `${config.walletUrl}/auto-import-secret-key#${accountId}/${accessKey.secretKey}`
  }

  const sign = async (content) => {
    if (!account)
      throw new Error("Signing not possible without a connected account");

    const keyPair = await keyStore.getKey(config.networkId, account);
    const public_key = keyPair.getPublicKey().toString();
    const msg = Buffer.from(content);
    const { signature } = keyPair.sign(msg);
    const hexSig = bytesToHex(signature);

    return {
      account_id: account,
      public_key,
      signature: hexSig,
    };
  };

  const signForHeader = async (content) => {
    const timestamp = Date.now();
    const sig = await sign(`${content}:${timestamp}`);

    return `${content}|${timestamp}|${sig.public_key}|${account}|${sig.signature}`
  }

  return {
    account: {
      login,
      logout,
      isLoggedIn: !!account,
      account,
      accessKeyType,
      loginFullAccess,
      getKeyObject,
      createSubAccount,
      wallet,
      sign,
      signForHeader
    }
  };
};

export default useNear;
